<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'min(980px, 96vw)' }"
  (onShow)="onShow()"
  (onHide)="close()"
>
  <ng-template pTemplate="header">
    <div style="display:flex; align-items:center; gap: 0.75rem;">
      <i class="pi pi-map-marker"></i>
      <span>
        Posizione: {{ referenza?.titoloBreve || 'Referenza' }}
      </span>
    </div>
  </ng-template>

  <div style="display:flex; flex-direction: column; gap: 1rem;">
   <!--  <div>
      <small style="color: var(--text-color-secondary);">
        Clicca sulla mappa per impostare la posizione. Se già presente, puoi trascinare il marker.
      </small>
    </div> -->

    <section class="geocode-box">
      <header class="geocode-header">
        <div class="geocode-title">
          <i class="pi pi-map-marker"></i>
          <span>Posizione</span>
        </div>
        <div class="geocode-header-actions">
          <button
            pButton
            type="button"
            icon="pi pi-question-circle"
            label="Come funziona"
            class="p-button-text p-button-sm"
            pTooltip="Puoi cercare la posizione della referenza indicando le coordinate oppure cercarle partendo dall'indirizzo e la città con «Indirizzo + Città» oppure con la sola «Città».
Se non troviamo una posizione precisa, ti posizioniamo sul centro della città.
Poi puoi trascinare il marker per rifinire."
            tooltipPosition="left"
            [tooltipStyleClass]="'tooltip-wide'"
          ></button>
        </div>
      </header>

      <div class="geocode-body">
        <p-tabView styleClass="posizione-tabs">
          <p-tabPanel header="Coordinate">
            <div class="coords-tab">
              <div class="coords-editor always">
                <div class="geocode-fields-inline">
                  <div class="field">
                    <label>Latitudine</label>
                    <p-inputNumber
                      [(ngModel)]="coordEditLat"
                      [ngModelOptions]="{ standalone: true }"
                      [min]="-90"
                      [max]="90"
                      mode="decimal"
                      [maxFractionDigits]="8"
                      [useGrouping]="false"
                      placeholder="Es: 45.036083"
                    ></p-inputNumber>
                  </div>
                  <div class="field">
                    <label>Longitudine</label>
                    <p-inputNumber
                      [(ngModel)]="coordEditLng"
                      [ngModelOptions]="{ standalone: true }"
                      [min]="-180"
                      [max]="180"
                      mode="decimal"
                      [maxFractionDigits]="8"
                      [useGrouping]="false"
                      placeholder="Es: 7.419505"
                    ></p-inputNumber>
                  </div>

                  <div class="field actions-field">
                    <label class="actions-label" aria-hidden="true">Azione</label>
                    <div class="actions-row">
                      <button
                        pButton
                        type="button"
                        icon="pi pi-check"
                        label="Applica"
                        class="p-button-sm"
                        (click)="applyCoordsEdit()"
                        [disabled]="!canModify"
                      ></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </p-tabPanel>

          <p-tabPanel header="Trova da indirizzo">
            <div class="geocode-fields-inline geocode-fields-inline--address">
              <div class="field">
                <label for="geo-address">Civico</label>
                <input
                  id="geo-address"
                  type="text"
                  pInputText
                  [(ngModel)]="addressInput"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="Es: Via Roma 10"
                  [disabled]="!canModify"
                  (keyup.enter)="searchByAddressAndCity()"
                />
              </div>

              <div class="field">
                <label for="geo-city">Città</label>
                <input
                  id="geo-city"
                  type="text"
                  pInputText
                  [(ngModel)]="cityInput"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="Es: Bologna"
                  [disabled]="!canModify"
                  (keyup.enter)="searchByAddressAndCity()"
                />
              </div>

              <div class="field actions-field">
                <label class="actions-label" aria-hidden="true">Azione</label>
                <div class="actions-row">
                  <button
                    pButton
                    type="button"
                    icon="pi pi-search"
                    label="Cerca"
                    class="p-button-sm"
                    [loading]="searching"
                    [disabled]="!canModify"
                    (click)="searchByAddressAndCity()"
                  ></button>
                </div>
              </div>
            </div>


          </p-tabPanel>
        </p-tabView>
      </div>
    </section>

    <app-leaflet-map
      [heightPx]="460"
      [center]="mapCenter"
      [zoom]="mapZoom"
      [selectable]="true"
      [markerDraggable]="true"
      [resizeToken]="mapResizeToken"
      [selectedPosition]="selectedPosition"
      (selectedPositionChange)="onMapSelectedPositionChange($event)"
    ></app-leaflet-map>

  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Annulla"
      class="p-button-text"
      (click)="close()"
    ></button>

    <button
      pButton
      type="button"
      icon="pi pi-times"
      label="Rimuovi posizione"
      class="p-button-outlined p-button-danger"
      (click)="removePosizione()"
      *ngIf="lat !== null && lng !== null"
      [disabled]="!canModify"
    ></button>

    <button
      pButton
      type="button"
      label="Salva posizione"
      icon="pi pi-check"
      [loading]="saving"
      [disabled]="!canModify || !isDirty"
      (click)="save()"
    ></button>
  </ng-template>
</p-dialog>

